// Deals Management Permissions

export const DEALS_INDEX = 146;
export const DEALS_STORE = 147;
export const DEALS_EXPORT = 1345;
export const DEALS_UPDATE_STAGE = 149;
export const DEALS_UPDATE = 150;
export const DEALS_SHOW = DEALS_INDEX;

// Pipeline actions — registered by the amer-laravel migration
// 2026_08_05_000008_add_crm_structure_refactor_permissions. The ids below are the
// central-assigned approval numbers and must be confirmed against the central
// permission-key registry before release.
/** deals.destroy */
export const DEALS_DESTROY = 1442;
/** deals.restore */
export const DEALS_RESTORE = 1443;
/** deals.assign_agent */
export const DEALS_ASSIGN_AGENT = 1444;
/** deals.favorite */
export const DEALS_FAVORITE = 1445;
